// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-selector-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.team-selector-error {
  margin: 0 24px 16px;
  padding: 10px 14px;
  border-radius: 8px;
  background: rgba(255, 107, 107, 0.12);
  color: #c0392b;
  font-size: 14px;
}

.team-selector-modal {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
  position: relative;
}

.team-selector-header {
  text-align: center;
  margin-bottom: 2rem;
}

.team-selector-header h2 {
  color: #333;
  margin: 0 0 0.5rem 0;
  font-size: 1.8rem;
}

.team-selector-header p {
  color: #666;
  margin: 0;
  font-size: 1rem;
}

.team-selector-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.new-team-section,
.existing-teams-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.new-team-section label,
.existing-teams-section label {
  font-weight: 600;
  color: #333;
  font-size: 0.9rem;
}

.input-group {
  display: flex;
  gap: 0.5rem;
}

.team-input {
  flex: 1 1;
  padding: 0.75rem;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.team-input:focus {
  outline: none;
  border-color: #667eea;
}

.add-team-btn {
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.add-team-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);
  transform: translateY(-1px);
}

.add-team-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
}

.teams-dropdown {
  position: relative;
}

.teams-dropdown-toggle {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  background: white;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: border-color 0.2s;
}

.teams-dropdown-toggle:hover {
  border-color: #667eea;
}

.dropdown-arrow {
  font-size: 0.8rem;
  transition: transform 0.2s;
}

.teams-dropdown-toggle.active .dropdown-arrow {
  transform: rotate(180deg);
}

.teams-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 2px solid #e9ecef;
  border-top: none;
  border-radius: 0 0 6px 6px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  animation: slideDown 0.2s ease-out;
}

.team-option {
  width: 100%;
  padding: 0.75rem;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s;
}

.team-option:hover {
  background: #f8f9fa;
}

.team-option.selected {
  background: #667eea;
  color: white;
}

.no-teams-message {
  padding: 0.75rem;
  text-align: center;
  color: #666;
  font-style: italic;
}

.selected-team-info {
  background: #e8f5e8;
  border: 1px solid #c3e6c3;
  border-radius: 6px;
  padding: 1rem;
  text-align: center;
}

.selected-team-info p {
  margin: 0;
  color: #2d5a2d;
}

/* Сообщение об ошибке блокировки */
.lock-error-message {
  background: #fee;
  color: #c53030;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #fed7d7;
  margin: 16px 0;
  font-size: 14px;
  text-align: center;
  animation: fadeIn 0.3s ease;
}

.lock-error-message span {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Анимации */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Темная тема */
.dark-theme .team-selector-modal {
  background: #2d3748;
  color: #e2e8f0;
}

.dark-theme .team-selector-header h2 {
  color: #e2e8f0;
}

.dark-theme .team-selector-header p {
  color: #a0aec0;
}

.dark-theme .team-input,
.dark-theme .teams-dropdown-toggle {
  background: #4a5568;
  border-color: #718096;
  color: #e2e8f0;
}

.dark-theme .team-input:focus,
.dark-theme .teams-dropdown-toggle:hover {
  border-color: #667eea;
}

.dark-theme .teams-dropdown-menu {
  background: #4a5568;
  border-color: #718096;
}

.dark-theme .team-option {
  color: #e2e8f0;
}

.dark-theme .team-option:hover {
  background: #2d3748;
}

.dark-theme .team-option.selected {
  background: #667eea;
  color: white;
}

.dark-theme .selected-team-info {
  background: #2d5a2d;
  border-color: #4a7c59;
  color: #e2e8f0;
}

/* Темная тема для сообщения об ошибке */
.dark-theme .lock-error-message {
  background: #742a2a;
  border-color: #c53030;
  color: #fed7d7;
}

/* Адаптивность */
@media (max-width: 600px) {
  .team-selector-modal {
    margin: 1rem;
    padding: 1.5rem;
  }
  
  .input-group {
    flex-direction: column;
  }
  
  .add-team-btn {
    width: 100%;
  }
}

.team-selector-close {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  color: #888;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 10;
  transition: color 0.2s;
}
.team-selector-close:hover {
  color: #dc3545;
} 

/* Анимация для кнопок при загрузке */
.dropdown-item:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.dropdown-item.loading {
  position: relative;
  color: transparent;
}

.dropdown-item.loading::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3bbddb;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} 

/* Поп-ап для занятой команды */
.locked-team-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease-out;
}

.locked-team-popup {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  padding: 0;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(220, 38, 38, 0.2);
  animation: popupSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

@keyframes popupSlideIn {
  0% {
    opacity: 0;
    transform: translateY(-30px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.popup-header {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  padding: 1.5rem;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.popup-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  animation: shimmer 2s infinite;
}

.popup-icon {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  animation: bounce 1s ease-in-out infinite;
  display: block;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-5px); }
  60% { transform: translateY(-3px); }
}

.popup-header h3 {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.popup-body {
  padding: 1.5rem;
  text-align: center;
}

.popup-body p {
  margin: 0 0 0.75rem 0;
  color: #374151;
  line-height: 1.5;
}

.popup-body p:last-of-type {
  margin-bottom: 0;
}

.popup-user {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 0.75rem;
  margin: 1rem 0;
  color: #991b1b;
  font-weight: 500;
}

.popup-user span {
  color: #dc2626;
  font-weight: 600;
}

.popup-hint {
  font-size: 0.9rem;
  color: #6b7280;
  font-style: italic;
}

.popup-close {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 1.5rem 1.5rem 1.5rem;
  width: calc(100% - 3rem);
}

.popup-close:hover {
  background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(220, 38, 38, 0.3);
}

.popup-close:active {
  transform: translateY(0);
}

/* Темная тема для поп-апа */
.dark-theme .locked-team-popup {
  background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
  border-color: rgba(220, 38, 38, 0.4);
}

.dark-theme .popup-body p {
  color: #e2e8f0;
}

.dark-theme .popup-user {
  background: #742a2a;
  border-color: #9b2c2c;
  color: #fed7d7;
}

.dark-theme .popup-user span {
  color: #fc8181;
}

.dark-theme .popup-hint {
  color: #a0aec0;
}

/* Адаптивность для поп-апа */
@media (max-width: 480px) {
  .locked-team-popup {
    width: 95%;
    margin: 1rem;
  }
  
  .popup-header {
    padding: 1rem;
  }
  
  .popup-body {
    padding: 1rem;
  }
  
  .popup-close {
    margin: 0 1rem 1rem 1rem;
    width: calc(100% - 2rem);
  }
  
  .popup-header h3 {
    font-size: 1.1rem;
  }
  
  .popup-icon {
    font-size: 2rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/TeamSelector.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,aAAa;AACb;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,wCAAwC;EACxC,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kGAAkG;EAClG,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0BAA0B,wBAAwB,EAAE;EACpD,MAAM,2BAA2B,EAAE;EACnC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".team-selector-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n.team-selector-error {\r\n  margin: 0 24px 16px;\r\n  padding: 10px 14px;\r\n  border-radius: 8px;\r\n  background: rgba(255, 107, 107, 0.12);\r\n  color: #c0392b;\r\n  font-size: 14px;\r\n}\r\n\r\n.team-selector-modal {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 2rem;\r\n  max-width: 500px;\r\n  width: 90%;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\r\n  animation: slideIn 0.3s ease-out;\r\n  position: relative;\r\n}\r\n\r\n.team-selector-header {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.team-selector-header h2 {\r\n  color: #333;\r\n  margin: 0 0 0.5rem 0;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.team-selector-header p {\r\n  color: #666;\r\n  margin: 0;\r\n  font-size: 1rem;\r\n}\r\n\r\n.team-selector-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.new-team-section,\r\n.existing-teams-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.new-team-section label,\r\n.existing-teams-section label {\r\n  font-weight: 600;\r\n  color: #333;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.input-group {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.team-input {\r\n  flex: 1;\r\n  padding: 0.75rem;\r\n  border: 2px solid #e9ecef;\r\n  border-radius: 6px;\r\n  font-size: 1rem;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.team-input:focus {\r\n  outline: none;\r\n  border-color: #667eea;\r\n}\r\n\r\n.add-team-btn {\r\n  padding: 0.75rem 1.5rem;\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.add-team-btn:hover:not(:disabled) {\r\n  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.add-team-btn:disabled {\r\n  background: #ccc;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n.teams-dropdown {\r\n  position: relative;\r\n}\r\n\r\n.teams-dropdown-toggle {\r\n  width: 100%;\r\n  padding: 0.75rem;\r\n  border: 2px solid #e9ecef;\r\n  border-radius: 6px;\r\n  background: white;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.teams-dropdown-toggle:hover {\r\n  border-color: #667eea;\r\n}\r\n\r\n.dropdown-arrow {\r\n  font-size: 0.8rem;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.teams-dropdown-toggle.active .dropdown-arrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.teams-dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  background: white;\r\n  border: 2px solid #e9ecef;\r\n  border-top: none;\r\n  border-radius: 0 0 6px 6px;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  z-index: 10;\r\n  animation: slideDown 0.2s ease-out;\r\n}\r\n\r\n.team-option {\r\n  width: 100%;\r\n  padding: 0.75rem;\r\n  border: none;\r\n  background: none;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.team-option:hover {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.team-option.selected {\r\n  background: #667eea;\r\n  color: white;\r\n}\r\n\r\n.no-teams-message {\r\n  padding: 0.75rem;\r\n  text-align: center;\r\n  color: #666;\r\n  font-style: italic;\r\n}\r\n\r\n.selected-team-info {\r\n  background: #e8f5e8;\r\n  border: 1px solid #c3e6c3;\r\n  border-radius: 6px;\r\n  padding: 1rem;\r\n  text-align: center;\r\n}\r\n\r\n.selected-team-info p {\r\n  margin: 0;\r\n  color: #2d5a2d;\r\n}\r\n\r\n/* Сообщение об ошибке блокировки */\r\n.lock-error-message {\r\n  background: #fee;\r\n  color: #c53030;\r\n  padding: 12px 16px;\r\n  border-radius: 8px;\r\n  border: 1px solid #fed7d7;\r\n  margin: 16px 0;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  animation: fadeIn 0.3s ease;\r\n}\r\n\r\n.lock-error-message span {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n}\r\n\r\n/* Анимации */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-20px) scale(0.95);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n@keyframes slideDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Темная тема */\r\n.dark-theme .team-selector-modal {\r\n  background: #2d3748;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .team-selector-header h2 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .team-selector-header p {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .team-input,\r\n.dark-theme .teams-dropdown-toggle {\r\n  background: #4a5568;\r\n  border-color: #718096;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .team-input:focus,\r\n.dark-theme .teams-dropdown-toggle:hover {\r\n  border-color: #667eea;\r\n}\r\n\r\n.dark-theme .teams-dropdown-menu {\r\n  background: #4a5568;\r\n  border-color: #718096;\r\n}\r\n\r\n.dark-theme .team-option {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .team-option:hover {\r\n  background: #2d3748;\r\n}\r\n\r\n.dark-theme .team-option.selected {\r\n  background: #667eea;\r\n  color: white;\r\n}\r\n\r\n.dark-theme .selected-team-info {\r\n  background: #2d5a2d;\r\n  border-color: #4a7c59;\r\n  color: #e2e8f0;\r\n}\r\n\r\n/* Темная тема для сообщения об ошибке */\r\n.dark-theme .lock-error-message {\r\n  background: #742a2a;\r\n  border-color: #c53030;\r\n  color: #fed7d7;\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 600px) {\r\n  .team-selector-modal {\r\n    margin: 1rem;\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .input-group {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .add-team-btn {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.team-selector-close {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 16px;\r\n  background: none;\r\n  border: none;\r\n  color: #888;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  z-index: 10;\r\n  transition: color 0.2s;\r\n}\r\n.team-selector-close:hover {\r\n  color: #dc3545;\r\n} \r\n\r\n/* Анимация для кнопок при загрузке */\r\n.dropdown-item:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.dropdown-item.loading {\r\n  position: relative;\r\n  color: transparent;\r\n}\r\n\r\n.dropdown-item.loading::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 16px;\r\n  height: 16px;\r\n  margin: -8px 0 0 -8px;\r\n  border: 2px solid #f3f3f3;\r\n  border-top: 2px solid #3bbddb;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n} \r\n\r\n/* Поп-ап для занятой команды */\r\n.locked-team-popup-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10000;\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n.locked-team-popup {\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\r\n  border-radius: 16px;\r\n  padding: 0;\r\n  max-width: 400px;\r\n  width: 90%;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\r\n  border: 1px solid rgba(220, 38, 38, 0.2);\r\n  animation: popupSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);\r\n  overflow: hidden;\r\n}\r\n\r\n@keyframes popupSlideIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(-30px) scale(0.9);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n.popup-header {\r\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\r\n  color: white;\r\n  padding: 1.5rem;\r\n  text-align: center;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.popup-header::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);\r\n  animation: shimmer 2s infinite;\r\n}\r\n\r\n.popup-icon {\r\n  font-size: 2.5rem;\r\n  margin-bottom: 0.5rem;\r\n  animation: bounce 1s ease-in-out infinite;\r\n  display: block;\r\n}\r\n\r\n@keyframes bounce {\r\n  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }\r\n  40% { transform: translateY(-5px); }\r\n  60% { transform: translateY(-3px); }\r\n}\r\n\r\n.popup-header h3 {\r\n  margin: 0;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.popup-body {\r\n  padding: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.popup-body p {\r\n  margin: 0 0 0.75rem 0;\r\n  color: #374151;\r\n  line-height: 1.5;\r\n}\r\n\r\n.popup-body p:last-of-type {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.popup-user {\r\n  background: #fef2f2;\r\n  border: 1px solid #fecaca;\r\n  border-radius: 8px;\r\n  padding: 0.75rem;\r\n  margin: 1rem 0;\r\n  color: #991b1b;\r\n  font-weight: 500;\r\n}\r\n\r\n.popup-user span {\r\n  color: #dc2626;\r\n  font-weight: 600;\r\n}\r\n\r\n.popup-hint {\r\n  font-size: 0.9rem;\r\n  color: #6b7280;\r\n  font-style: italic;\r\n}\r\n\r\n.popup-close {\r\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  margin: 0 1.5rem 1.5rem 1.5rem;\r\n  width: calc(100% - 3rem);\r\n}\r\n\r\n.popup-close:hover {\r\n  background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(220, 38, 38, 0.3);\r\n}\r\n\r\n.popup-close:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n/* Темная тема для поп-апа */\r\n.dark-theme .locked-team-popup {\r\n  background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);\r\n  border-color: rgba(220, 38, 38, 0.4);\r\n}\r\n\r\n.dark-theme .popup-body p {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .popup-user {\r\n  background: #742a2a;\r\n  border-color: #9b2c2c;\r\n  color: #fed7d7;\r\n}\r\n\r\n.dark-theme .popup-user span {\r\n  color: #fc8181;\r\n}\r\n\r\n.dark-theme .popup-hint {\r\n  color: #a0aec0;\r\n}\r\n\r\n/* Адаптивность для поп-апа */\r\n@media (max-width: 480px) {\r\n  .locked-team-popup {\r\n    width: 95%;\r\n    margin: 1rem;\r\n  }\r\n  \r\n  .popup-header {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .popup-body {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .popup-close {\r\n    margin: 0 1rem 1rem 1rem;\r\n    width: calc(100% - 2rem);\r\n  }\r\n  \r\n  .popup-header h3 {\r\n    font-size: 1.1rem;\r\n  }\r\n  \r\n  .popup-icon {\r\n    font-size: 2rem;\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
